const initialState = {
  navExpand: true,
};

export default (state = initialState, action) => {
  return { navExpand: action.payload };
};
